import { useEffect, useState } from 'react';

import { NotificationFactoryInterface } from './notificationFactoryInterface';
import { NotificationReadingConsentReactivateFactory } from './notificationReadingConsentReactivateFactory';
import { NotificationResponse } from '../models/NotificationResponse';
import { NotificationSmartMeterCreatedFactory } from './notificationSmartMeterCratedFactory';
import { NotificationSmartMeterFirstDataFactory } from './notificationSmartMeterFirstDataFactory';
import { NotificationTypeEnum } from '../enum/NotificationTypeEnum';
import { useNavigate } from 'react-router-dom';

export function useNotificationFactory(
  notification: NotificationResponse | null
): NotificationFactoryInterface | null {
  const navigate = useNavigate();
  const [factory, setFactory] = useState<NotificationFactoryInterface | null>(null);
  useEffect(() => {
    function getInstance(notification: NotificationResponse) {
      switch (notification.type) {
        case NotificationTypeEnum.FIRST_METER_DATA:
          return new NotificationSmartMeterFirstDataFactory(notification, navigate);
        case NotificationTypeEnum.SMART_METER_CREATED:
          return new NotificationSmartMeterCreatedFactory(notification, navigate);
        case NotificationTypeEnum.REACTIVATE_READING_CONSENT:
          return new NotificationReadingConsentReactivateFactory(notification, navigate);
        case NotificationTypeEnum.ACTIVATE_READING_CONSENT:
          return new NotificationReadingConsentReactivateFactory(notification, navigate);
        default:
          throw new Error(`No factory found for notification type: ${notification.type}`);
      }
    }
    if (!notification) {
      return;
    }
    setFactory(getInstance(notification));
  }, [notification, navigate]);

  return factory;
}
